import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import toastr from "toastr";
import { Accordion, Card, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Col } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { Row } from "react-bootstrap";
import { FiMinusCircle, FiPlusCircle } from "react-icons/fi";
import { MdKeyboardArrowRight } from "react-icons/md";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";

import CustomDateTime from "app/Components/DateTimeCustom/CustomDateTime";
import { getAllTrainingCategories } from "app/_services/ehs/ehsServices";
import IncidentDetailsInfo from "./Investigator/IncidentDetailsInfo";
import MultiLineTextArea from "./MultiLineTextArea";
import IncidentEvidences from "./IncidentEvidences";
import { UserService } from "app/_services/UserService/UserService";
import { DepartmentService } from "app/_services/UserManagement/DepartmentService";
import { getAllAreaOfOperation } from "app/_services/ehs/ehsAreaOfOperationServices";
import {
  getIncidentReportById,
  updateIncidentInvestigation,
} from "app/_services/ehs/ehsIncidentServices";
import { Validation } from "app/_helpers/validation/Validation";
import {
  initialForm,
  initialCompliance,
  initialMitigationMeasure,
  initialTraining,
  initialSolution,
  initialCapa,
  initialWitnessStatement,
  initialRootCauseDescription,
  initialEvidence,
  investigationFormRules,
  complianceRules,
  witnessStatementRules,
  trainingRules,
  capaRules,
  mitigationMeasureRules,
  rootCauseDescriptionRules,
  solutionRules,
  evidenceRules,
  commentTypes,
  evidenceCategories,
  insuranceTabRules,
  investigationTabRules,
  incidentStatuses,
  severities,
  STAFFEMPLOYER,
  FORM_LABEL_OFFICER,
  INVESTIGATION_STATUS,
  initialOtherDocuments,
  initialIndirectCause,
  initialImmediateCause,
} from "./CONSTANTS";
import IncidentTimeline from "./IncidentTimeline";
import Capas from "../Capas";
import SingleFileUpload from "app/views/custom/components/FileUpload/SingleFileUpload";
import YesOrNo from "../YesOrNo.component";
import { CommmonService } from "app/_services/CommonService/CommonService";
import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";
import { getCapaOwner } from "app/_services/ehs/ehsCapaOwner";
import ViewComments from "./ViewComments";
import moment from "moment";
import { disableFutureDate, YYYYMMDDFormat } from "app/_helpers/dateHelper";
import ReviewerDetailsInfo from "./Reviewer/ReviewerDetailsInfo";
import { contractorDropdownLabel, employeeDropdownLabel } from "app/_helpers/helper";
import FormInput from "app/Components/_form/FormInput/FormInput";
import { getContractor } from "app/_services/Contractor/ContractorService";

const IncidentInvestigationForm = ({
  match: {
    params: { id: incidentDetailsId = null, siteId },
  },
  history,
  user,
}) => {
  const [tab, setTab] = useState(+CommmonService.getQueryParam("tab") || 1);
  const [form, setForm] = useState({
    ...initialForm,
    id: incidentDetailsId,
    avoidable: "No",
  });
  const [errorForm, setErrorForm] = useState({
    ...initialForm,
    couldAvoidBy: "",
    fireCause: "",
    cause: "",
    avoidable: "",
  });
  const [users, setUsers] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [trainingCategories, setTrainingCategories] = useState([]);

  const [compliances, setCompliances] = useState([]);
  const [trainings, setTrainings] = useState([]);
  const [witnessStatements, setWitnessStatements] = useState([
    { ...initialWitnessStatement, incidentDetailsId },
  ]);
  const [capas, setCapas] = useState([]);
  const [evidences, setEvidences] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [mitigationMeasures, setMitigationMeasures] = useState([]);
  const [rootCauseDescriptions, setRootCauseDescriptions] = useState([
    { ...initialRootCauseDescription, incidentDetailsId },
  ]);
  const [indirectCause, setIndirectCause] = useState([
    { ...initialIndirectCause, incidentDetailsId },
  ]);
  const [immediateCause, setImmediateCause] = useState([
    { ...initialImmediateCause, incidentDetailsId },
  ]);
  const [rootCause, setRootCause] = useState("");
  const [solutions, setSolutions] = useState([]);
  const [comments, setComments] = useState([]);
  const [rootCauseOther, setRootCauseOther] = useState(false);
  const [uaOther, setUAOther] = useState(false);
  const [ucOther, setUCOther] = useState(false);
  const [pfOther, setPFOther] = useState(false);
  const [jfOther, setJFOther] = useState(false);

  const [compliancesErrors, setCompliancesErrors] = useState([]);
  const [trainingsErrors, setTrainingsErrors] = useState([]);
  const [witnessStatementsErrors, setWitnessStatementsErrors] = useState([]);
  const [capasErrors, setCapasErrors] = useState([]);
  const [evidencesErrors, setEvidencesErrors] = useState([]);
  const [documentsErrors, setDocumentsErrors] = useState([]);
  const [mitigationMeasuresErrors, setMitigationMeasuresErrors] = useState([]);
  const [rootCauseDescriptionsErrors, setRootCauseDescriptionsErrors] = useState([]);
  const [indirectCauseErrors, setIndirectCauseErrors] = useState([]);
  const [immediateCauseErrors, setImmediateCauseErrors] = useState([]);
  const [solutionsErrors, setSolutionsErrors] = useState([]);
  const [contractors, setContractors] = useState([]);

  const [saving, setSaving] = useState(false);

  const [area, setArea] = useState([]);
  const [capaOwners, setCapaOwners] = useState([]);

  useEffect(() => {
    getContractor().then((response) => {
      if (!response?.data) return;

      setContractors(response.data);
    });
  }, []);

  const onChange = ({ target: { name, type, value, checked } }) => {
    if (
      name === "solutionType" &&
      !value &&
      solutions?.filter((data) => !data.deleted).length
    )
      return toastr.warning("Please delete all rows first before un-selecting!");

    if (type === "checkbox" && !checked)
      switch (name) {
        case "solutionRequired":
          if (solutions?.filter((data) => !data.deleted).length)
            return toastr.warning("Please delete all rows first!");
          break;
        case "trainingRequired":
          if (trainings?.filter((data) => !data.deleted).length)
            return toastr.warning("Please delete all rows first!");
          break;
        case "complianceRequired":
          if (compliances?.filter((data) => !data.deleted).length)
            return toastr.warning("Please delete all rows first!");
          break;
        case "witnessStatementRequired":
          if (witnessStatements?.filter((data) => !data.deleted).length)
            return toastr.warning("Please delete all rows first!");
          break;
        case "rootCauseAnalysisRequired":
          if (
            rootCauseDescriptions?.filter((data) => !data.deleted).length ||
            indirectCause?.filter((data) => !data.deleted).length ||
            immediateCause?.filter((data) => !data.deleted).length
          )
            return toastr.warning("Please delete all rows first!");
          break;
        case "capaRequired":
          if (capas?.filter((data) => !data.deleted).length)
            return toastr.warning("Please delete all rows first!");
          break;
        case "evidencesRequired":
          if (evidences?.filter((data) => !data.deleted).length)
            return toastr.warning("Please delete all rows first!");
          break;
        case "otherDocumentRequired":
          if (documents?.filter((data) => !data.deleted).length)
            return toastr.warning("Please delete all rows first!");
          break;
        default:
          break;
      }

    setForm((prevForm) => {
      if (name === "insuranceApprovedAmount" && +value > prevForm.insuranceClaimAmount) {
        toastr.warning("Approved amount can not be more than Claim Amount!");
        return prevForm;
      }
      if (name === "insuranceClaimAmount" && +value < prevForm.insuranceApprovedAmount) {
        toastr.warning("Claim amount can not be less than Approved Claim Amount!");
        return prevForm;
      }

      // return;

      const newForm = { ...prevForm, [name]: type === "checkbox" ? checked : value };
      // console.log("/****/", newForm);

      if (newForm.rootCause == "other") {
        setRootCauseOther(true);
      } else {
        newForm.rootCauseOther = "";
        setRootCauseOther(false);
      }
      if (newForm.causeImmediate == "UAOther") {
        newForm.ucCauseOther = "";
        setUAOther(true);
        setUCOther(false);
      } else if (newForm.causeImmediate == "UCOther") {
        setUCOther(true);
        newForm.uaCauseOther = "";
        setUAOther(false);
      } else {
        newForm.ucCauseOther = "";
        newForm.uaCauseOther = "";
        setUCOther(false);
        setUAOther(false);
      }

      if (newForm.causeIndirect == "pfOther") {
        newForm.jfCauseOther = "";
        setPFOther(true);
        setJFOther(false);
      } else if (newForm.causeIndirect == "jfOther") {
        setJFOther(true);
        newForm.pfCauseOther = "";
        setPFOther(false);
      } else {
        newForm.pfCauseOther = "";
        newForm.jfCauseOther = "";
        setJFOther(false);
        setPFOther(false);
      }

      if (name === "environmentalImpact" && value === "No")
        newForm.environmentalAssessment = "";
      if (name === "rootCauseAnalysisRequired" && !checked) newForm.rootCause = "";
      if (name === "solutionRequired" && !checked) newForm.solutionType = "";
      if (name === "insuranceClaimAmount" || name === "insuranceApprovedAmount")
        newForm.insuranceUnapprovedAmount =
          +newForm.insuranceClaimAmount - +newForm.insuranceApprovedAmount;

      // if (name === "rootCauseAnalysisRequired" && checked) {
      //   newForm.rootCauseAnalysisRequired = true;
      // }
      // if (name === "witnessStatementRequired" && checked) {
      //   newForm.witnessStatementRequired = true;
      // }

      if (name === "insuranceApplicable") {
        if (checked) {
          newForm.directIncidentLoss = "";
          newForm.insuranceClaimAmount = "";
          newForm.insuranceApprovedAmount = "";
          newForm.insuranceUnapprovedAmount = "";
        } else {
          newForm.insuranceClaimRaised = false;
          newForm.insuranceApplicable = false;
          newForm.directIncidentLossToEquipment = false;
          newForm.directIncidentLoss = 0;
          newForm.insuranceClaimAmount = 0;
          newForm.insuranceApprovedAmount = 0;
          newForm.insuranceUnapprovedAmount = 0;
        }
      }

      return newForm;
    });
  };

  const onChangeCheckbox = (
    { target: { name, value, type, checked } },
    multiple = true,
    maxLimit = 2
  ) => {
    setForm((prevForm) => {
      const newForm = { ...prevForm };

      if (type !== "checkbox") {
        newForm[name][0] = value;

        return newForm;
      }

      if (!multiple) {
        if (checked) newForm[name] = ["", value];
        else newForm[name] = [""];
      } else {
        if (!checked) {
          newForm[name] = newForm[name].filter((d, i) => i !== 0 && d !== value);
          if (value === "other") newForm[name][0] = "";
        } else {
          if (value !== "notApplicable") {
            if (newForm[name][1] === "notApplicable") newForm[name].splice(1, 1);
            if (newForm[name].length === maxLimit + 1) {
              newForm[name].splice(1, 1);
              if (!newForm[name].includes("other")) newForm[name][0] = "";
            }
            newForm[name].push(value);
          } else newForm[name] = ["", "notApplicable"];
        }
      }

      return newForm;
    });
  };

  const addMitigationMeasure = () =>
    setMitigationMeasures((previous) => [
      ...previous,
      { ...initialMitigationMeasure, incidentDetailsId },
    ]);
  const deleteMitigationMeasure = (index) =>
    setMitigationMeasures((previous) => {
      if (previous.length === 1) {
        toastr.warning("Minimum one row is required!");
        return previous;
      }

      if (previous[index].id) previous[index].deleted = 1;
      else previous.splice(index, 1);

      return [...previous];
    });
  const onChangeMitigationMeasure = ({ name, value, type, checked, index }) => {
    setMitigationMeasures((prevMitigationMeasures) =>
      prevMitigationMeasures.map((data, idx) => {
        if (idx !== index) return data;

        data[name] = type === "checkbox" ? checked : value;
        return data;
      })
    );
  };

  const addWitnessStatement = () =>
    setWitnessStatements((previous) => [
      ...previous,
      { ...initialWitnessStatement, incidentDetailsId },
    ]);
  const deleteWitnessStatement = (index) =>
    setWitnessStatements((previous) =>
      previous
        .map((data, idx) =>
          idx !== index ? data : data.id ? { ...data, deleted: 1 } : null
        )
        .filter((data) => !!data)
    );
  const onChangeWitnessStatement = ({ name, value, type, checked, index }) => {
    setWitnessStatements((prevWitnessStatements) =>
      prevWitnessStatements.map((data, idx) => {
        if (idx !== index) return data;

        data[name] = type === "checkbox" ? checked : value;
        return data;
      })
    );
  };

  const addRootCauseDescription = () =>
    setRootCauseDescriptions((previous) => [
      ...previous,
      { ...initialRootCauseDescription, incidentDetailsId },
    ]);
  const deleteRootCauseDescription = (index) =>
    setRootCauseDescriptions((previous) =>
      previous
        .map((data, idx) =>
          idx !== index ? data : data.id ? { ...data, deleted: 1 } : null
        )
        .filter((data) => !!data)
    );
  const onChangeRootCauseDescription = ({ name, value, type, checked, index }) => {
    setRootCauseDescriptions((prevRootCauseDescriptions) =>
      prevRootCauseDescriptions.map((data, idx) => {
        if (idx !== index) return data;

        data[name] = type === "checkbox" ? checked : value;
        return data;
      })
    );
  };

  const addIndirectCause = () =>
    setIndirectCause((previous) => [
      ...previous,
      { ...initialIndirectCause, incidentDetailsId },
    ]);
  const deleteIndirectCause = (index) =>
    setIndirectCause((previous) =>
      previous
        .map((data, idx) =>
          idx !== index ? data : data.id ? { ...data, deleted: 1 } : null
        )
        .filter((data) => !!data)
    );
  const onChangeIndirectCause = ({ name, value, type, checked, index }) => {
    setIndirectCause((prev) =>
      prev.map((data, idx) => {
        if (idx !== index) return data;

        data[name] = type === "checkbox" ? checked : value;
        return data;
      })
    );
  };

  const addImmediateCause = () =>
    setImmediateCause((previous) => [
      ...previous,
      { ...initialImmediateCause, incidentDetailsId },
    ]);
  const deleteImmediateCause = (index) =>
    setImmediateCause((previous) =>
      previous
        .map((data, idx) =>
          idx !== index ? data : data.id ? { ...data, deleted: 1 } : null
        )
        .filter((data) => !!data)
    );
  const onChangeImmediateCause = ({ name, value, type, checked, index }) => {
    setImmediateCause((prev) =>
      prev.map((data, idx) => {
        if (idx !== index) return data;

        data[name] = type === "checkbox" ? checked : value;
        return data;
      })
    );
  };

  const addCapa = () => {
    // if (!form?.areaId) return toastr.info("Please Select Area  First");

    // const ownerId = capaOwners.find((data) => form?.areaId === data.areaOfOperationId)?.userId;

    // if (!ownerId) return toastr.info("Owner Id  Required");

    setCapas((previous) => [
      ...previous,
      {
        ...initialCapa,
        // areaId: form.areaId,
        // subAreaId: form.subAreaId,
        siteId: form.siteId || "",
        workArea: form.workArea?.name || "",
        // ownerId: ownerId,
        incidentDetailsId,
        source: "Incident Management",
      },
    ]);
  };

  const deleteCapa = (index) =>
    setCapas((previous) =>
      previous
        .map((data, idx) =>
          idx !== index ? data : data.id ? { ...data, deleted: 1 } : null
        )
        .filter((data) => !!data)
    );
  const onChangeCapa = ({ name, value, type, checked, index }) => {
    setCapas((prevCapas) =>
      prevCapas.map((data, idx) => {
        if (idx !== index) return data;
        if (name === "areaId") {
          data["ownerId"] =
            capaOwners?.find((d) => value === d?.areaOfOperationId)?.userId || null;
          data["subAreaId"] = "";
        }

        data[name] = type === "checkbox" ? checked : value;
        return data;
      })
    );
  };

  const addEvidence = () =>
    setEvidences((previous) => [...previous, { ...initialEvidence, incidentDetailsId }]);
  const deleteEvidence = (index) =>
    setEvidences((previous) =>
      previous
        .map((data, idx) =>
          idx !== index ? data : data.id ? { ...data, deleted: 1 } : null
        )
        .filter((data) => !!data)
    );
  const onChangeEvidence = ({ name, value, type, checked, index }) => {
    setEvidences((prevEvidences) =>
      prevEvidences.map((data, idx) => {
        if (idx !== index) return data;

        data[name] = type === "checkbox" ? checked : value;
        return data;
      })
    );
  };
  const onChangeEvidenceFile = ({ responseData, index }) => {
    setEvidences((prevEvidences) =>
      prevEvidences.map((data, idx) => {
        if (idx !== index) return data;

        data.file = responseData;
        data.fileId = responseData.id;

        return data;
      })
    );
  };

  const addDocuments = () =>
    setDocuments((previous) => [
      ...previous,
      { ...initialOtherDocuments, incidentDetailsId },
    ]);
  const deleteDocuments = (index) =>
    setDocuments((previous) =>
      previous
        .map((data, idx) =>
          idx !== index ? data : data.id ? { ...data, deleted: 1 } : null
        )
        .filter((data) => !!data)
    );
  const onChangeDocuments = ({ name, value, type, checked, index }) => {
    setDocuments((prevEvidences) =>
      prevEvidences.map((data, idx) => {
        if (idx !== index) return data;

        data[name] = type === "checkbox" ? checked : value;
        return data;
      })
    );
  };
  const onChangeDocumentsFile = ({ responseData, index }) => {
    setDocuments((prevEvidences) =>
      prevEvidences.map((data, idx) => {
        if (idx !== index) return data;

        data.file = responseData;
        data.fileId = responseData.id;

        return data;
      })
    );
  };

  const onChangeFile = async (responseData, index) => {
    if (typeof index !== "number")
      setForm((prevForm) => ({
        ...prevForm,
        insuranceFileId: responseData.id,
        insuranceFile: responseData,
      }));
    else
      setWitnessStatements((previous) =>
        previous.map((data, idx) => {
          if (idx !== index) return data;
          data.fileId = responseData.id;
          data.file = responseData;

          return data;
        })
      );
  };

  const onDeleteFile = async (index) => {
    if (typeof index !== "number")
      setForm((prevForm) => ({
        ...prevForm,
        insuranceFileId: null,
        insuranceFile: null,
      }));
    else
      setWitnessStatements((previous) =>
        previous.map((data, idx) => {
          if (idx !== index) return data;
          data.fileId = null;
          data.file = null;

          return data;
        })
      );
  };

  const onSubmit = useCallback(
    async (validate, dontGoBack = false) => {
      if (dontGoBack) setTab((prev) => prev + 1);
      if (saving) return;
      setSaving(true);
      const toast = toastr.warning("Saving, please wait...");
      let flag = 0;

      const Rules = [...investigationFormRules];

      if (form.insuranceApplicable) Rules.splice(Rules.length, 0, ...insuranceTabRules);
      if (form.avoidable === "Yes")
        Rules.splice(Rules.length, 0, ...investigationTabRules);

      const errorObj = Validation(form, Rules);

      const compliancesErrorArray = compliances.map((data) =>
        data.deleted ? {} : Validation(data, complianceRules)
      );
      const witnessStatementsErrorArray = form?.witnessStatementRequired
        ? witnessStatements.map((data) =>
            data.deleted ? {} : Validation(data, witnessStatementRules)
          )
        : [];
      const trainingsErrorArray = trainings.map((data) =>
        data.deleted ? {} : Validation(data, trainingRules)
      );
      const capasErrorArray = capas.map((data) =>
        data.deleted
          ? {}
          : Validation(
              data,
              capaRules?.map((d) =>
                d?.field_name === "otherSubArea"
                  ? data?.subAreaId === 999
                    ? { ...d, isRequired: true }
                    : { ...d, isRequired: false }
                  : d
              )
            )
      );
      const mitigationMeasuresErrorArray = mitigationMeasures.map((data) =>
        data.deleted ? {} : Validation(data, mitigationMeasureRules)
      );
      const rootCauseDescriptionsErrorArray = form?.rootCauseAnalysisRequired
        ? rootCauseDescriptions.map((data) =>
            data.deleted ? {} : Validation(data, rootCauseDescriptionRules)
          )
        : [];
      const immediateCauseErrorArray = form?.rootCauseAnalysisRequired
        ? immediateCause.map((data) =>
            data.deleted ? {} : Validation(data, rootCauseDescriptionRules)
          )
        : [];
      const indirectCauseErrorArray = form?.rootCauseAnalysisRequired
        ? indirectCause.map((data) =>
            data.deleted ? {} : Validation(data, rootCauseDescriptionRules)
          )
        : [];
      const solutionsErrorArray = solutions.map((data) =>
        data.deleted ? {} : Validation(data, solutionRules)
      );
      const evidencesErrorArray = form?.evidencesRequired
        ? evidences.map((data) => (data.deleted ? {} : Validation(data, evidenceRules)))
        : [];
      const documentsErrorArray = form?.otherDocumentRequired
        ? documents.map((data) => (data.deleted ? {} : Validation(data, evidenceRules)))
        : [];

      if (!form.investigationCompleted)
        errorObj.investigationCompleted = "Please check this checkbox.";
      if (form.rootCauseAnalysisRequired) {
        if (!rootCauseDescriptions.length)
          errorObj.rootCause = "Minimum one row of Cause Descriptions is required!";
        if (!form.rootCause) errorObj.rootCause = "Root Cause is required!";

        if (!indirectCause.length)
          errorObj.causeIndirect = "Minimum one row of Cause Descriptions is required!";
        if (!form.causeIndirect) errorObj.causeIndirect = "Indirect Cause is required!";
        if (!immediateCause.length)
          errorObj.causeImmediate = "Minimum one row of Cause Descriptions is required!";
        if (!form.causeImmediate)
          errorObj.causeImmediate = "Immediate Cause is required!";
      }
      if (form.solutionRequired) {
        if (!solutions.length)
          errorObj.solutionType = "Minimum one row of Solution Descriptions is required!";
        if (!form.solutionType) errorObj.solutionType = "Solution Type is required!";
      }
      // if (form.capaRequired && !capas.filter((d) => !d.deleted).length)
      //   errorObj.capaRequired = "Minimum one row of CAPAs is required!";
      if (
        form.witnessStatementRequired &&
        !witnessStatements.filter((d) => !d.deleted).length
      )
        errorObj.witnessStatementRequired =
          "Minimum one row of Witness Statements is required!";
      if (form.trainingRequired && !trainings.filter((d) => !d.deleted).length)
        errorObj.trainingRequired = "Minimum one row of Trainings is required!";
      if (form.evidencesRequired && !evidences.filter((d) => !d.deleted).length)
        errorObj.evidencesRequired = "Minimum one row of Evidence is required!";
      if (form.complianceRequired && !compliances.filter((d) => !d.deleted).length)
        errorObj.complianceRequired = "Minimum one row of Compliance is required!";
      if (form.insuranceUnapprovedAmount < 0)
        errorObj.insuranceApprovedAmount =
          "Please reduce value (max up to Claim Amount)!";
      if (form.directIncidentLoss < 0)
        errorObj.directIncidentLoss = "Please enter a positive number.";
      if (form.insuranceClaimAmount < 0)
        errorObj.insuranceClaimAmount = "Please enter a positive number.";
      if (form.insuranceApprovedAmount < 0)
        errorObj.insuranceApprovedAmount = "Please enter a positive number.";

      console.log("++++++++", indirectCauseErrorArray);
      console.log("indirectCause", indirectCause);

      setErrorForm(validate ? errorObj : {});

      setCompliancesErrors(compliancesErrorArray);
      setWitnessStatementsErrors(witnessStatementsErrorArray);
      setTrainingsErrors(trainingsErrorArray);
      setCapasErrors(capasErrorArray);
      setMitigationMeasuresErrors(mitigationMeasuresErrorArray);
      setRootCauseDescriptionsErrors(rootCauseDescriptionsErrorArray);
      setImmediateCauseErrors(immediateCauseErrorArray);
      setIndirectCauseErrors(indirectCauseErrorArray);
      setSolutionsErrors(solutionsErrorArray);
      setEvidencesErrors(evidencesErrorArray);
      setDocumentsErrors(documentsErrorArray);

      if (validate) {
        // if (form?.cause?.includes("other", 1) && !form?.cause[0])
        //   errorObj.causeOther = "This field is Required.";
        // if (form?.fireCause?.includes("other", 1) && !form?.fireCause[0])
        //   errorObj.fireCauseOther = "This field is Required.";
        // if (form?.couldAvoidBy?.includes("other", 1) && !form?.couldAvoidBy[0])
        //   errorObj.couldAvoidByOther = "This field is Required.";
        if (form?.environmentalImpact === "Yes" && !form?.environmentalAssessment)
          errorObj.environmentalAssessment = "Environment Assessment is required.";
        for (const key in errorObj)
          if (errorObj[key]) {
            flag = 1;
            break;
          }
      }

      for (const array of [
        compliancesErrorArray,
        witnessStatementsErrorArray,
        trainingsErrorArray,
        capasErrorArray,
        mitigationMeasuresErrorArray,
        rootCauseDescriptionsErrorArray,
        immediateCauseErrorArray,
        indirectCauseErrorArray,
        solutionsErrorArray,
        evidencesErrorArray,
        documentsErrorArray,
      ])
        for (const errObj of array)
          for (const key in errObj)
            if (errObj[key]) {
              flag = 1;
              // console.log(key);
            }

      // console.log("form", form);

      // console.log("errorObj", errorObj);
      // console.log("compliancesErrorArray", compliancesErrorArray);
      // console.log("witnessStatementsErrorArray", witnessStatementsErrorArray);
      // console.log("trainingsErrorArray", trainingsErrorArray);
      // console.log("mitigationMeasuresErrorArray", mitigationMeasuresErrorArray);
      // console.log("rootCauseDescriptionsErrorArray", rootCauseDescriptionsErrorArray);
      // console.log("solutionsErrorArray", solutionsErrorArray);
      // console.log("evidencesErrorArray", evidencesErrorArray);

      // console.log("flag", flag);

      if (flag !== 0) {
        toastr.clear(toast);
        toastr.warning("Investigation inputs missing. Please complete all sections.");
        setSaving(false);
        return;
      }

      const response = await updateIncidentInvestigation(
        {
          ...form,
          compliances,
          trainings,
          witnessStatements: form?.witnessStatementRequired ? witnessStatements : [],
          capas,
          evidences: form?.evidencesRequired ? evidences : [],
          documents: form?.otherDocumentRequired ? documents : [],
          mitigationMeasures,
          rootCauseDescriptions: form?.rootCauseAnalysisRequired
            ? rootCauseDescriptions
            : [],
          immediateCause: form?.rootCauseAnalysisRequired ? immediateCause : [],
          indirectCause: form?.rootCauseAnalysisRequired ? indirectCause : [],
          //rootCause,
          solutions,
          // incidentStatus: validate
          //   ? incidentStatuses.investigationProgress
          //   : incidentStatuses.initialReview,
          investigationStatus: form.investigationCompleted
            ? INVESTIGATION_STATUS.completed
            : incidentStatuses.draft,
        },
        form?.investigationId
      );

      toastr.clear(toast);

      if (!response?.status) {
        setSaving(false);
        return toastr.error(response?.message);
      }

      toastr.success(response.message || "Success.");

      setEvidences((prev) =>
        prev.map((d, i) => {
          if (d.id) return d;
          d.id = response.data.evidences?.[i]?.id || null;
          return d;
        })
      );
      setDocuments((prev) =>
        prev.map((d, i) => {
          if (d.id) return d;
          d.id = response.data.documents?.[i]?.id || null;
          return d;
        })
      );
      setTrainings((prev) =>
        prev.map((d, i) => {
          if (d.id) return d;
          d.id = response.data.trainings?.[i]?.id || null;
          return d;
        })
      );
      setCapas((prev) =>
        prev.map((d, i) => {
          if (d.id) return d;
          d.id = response.data.capas?.[i]?.id || null;
          return d;
        })
      );
      setCompliances((prev) =>
        prev.map((d, i) => {
          if (d.id) return d;
          d.id = response.data.compliances?.[i]?.id || null;
          return d;
        })
      );
      setWitnessStatements((prev) =>
        prev.map((d, i) => {
          if (d.id) return d;
          d.id = response.data.witnessStatements?.[i]?.id || null;
          return d;
        })
      );

      setSaving(false);

      if (!dontGoBack)
        history.push(
          (siteId ? `/sites/${siteId}` : "") +
            "/health-safety-and-environment/incident-management"
        );
    },
    [
      saving,
      form,
      compliances,
      witnessStatements,
      trainings,
      capas,
      mitigationMeasures,
      rootCauseDescriptions,
      immediateCause,
      indirectCause,
      solutions,
      evidences,
      documents,
      history,
      siteId,
    ]
  );

  useEffect(() => {
    if (+tab > 0) CommmonService.updateQueryParam("tab", tab);
  }, [tab]);

  useEffect(() => {
    getAllTrainingCategories(`filter[status]=1`).then((response) => {
      if (!response?.data) return;

      setTrainingCategories(response.data);
    });
    UserService.getUsers("filter[status]=1").then((response) => {
      if (!response?.data) return;

      setUsers(response.data);
    });
    DepartmentService.getDepartment().then((response) => {
      if (!response?.data) return;

      setDepartments(response.data.departments);
    });
    getAllAreaOfOperation().then((response) => {
      if (!response?.data) return;
      setArea(response.data);
    });

    getCapaOwner().then((response) => {
      if (!response?.data) return;
      setCapaOwners(response.data.capaOwners);
    });
  }, []);

  useEffect(() => {
    if (!incidentDetailsId) return;
    getIncidentReportById(incidentDetailsId).then((response) => {
      if (!response?.data) return;

      setForm((prev) => {
        if (response.data.site?.siteType === 3) {
          prev.roName = response?.data?.site?.parentSite?.name;
          prev.roSiteId = response?.data?.site?.parentSite?.siteId;
        } else if (response?.data?.site?.siteType === 2) {
          prev.roName = response?.data?.site?.name;
          prev.roSiteId = response?.data?.site?.siteId;
        } else {
          prev.roName = "";
          prev.roSiteId = "";
        }

        return {
          ...prev,
          ...response.data,
          locationSiteId: response.data.site?.siteId,
          rootCause: response.data.investigationDetails?.rootCause,
          rootCauseAnalysisRequired: response.data.investigationDetails
            ?.rootCauseAnalysisRequired
            ? true
            : false,
        };
      });
      const investigationEvidence = response.data.evidences?.filter(
        (data) => data.category === "Investigation"
      );
      const otherDocumentsData = response.data.investigationDetails?.documents?.filter(
        (data) => data.category === "InvestigationOther"
      );

      //setForm(response.data);
      setCompliances(response.data.compliances || []);
      setTrainings(response.data.trainings || []);
      // console.log("response.data?.witnessStatements", response.data?.witnessStatements);
      setWitnessStatements(
        (response.data?.witnessStatements?.length &&
          response.data?.witnessStatements) || [
          { ...initialWitnessStatement, incidentDetailsId },
        ]
      );
      // form.witnessStatementRequired = response.data.investigationDetails?.witnessStatementRequired;
      setCapas(response.data.capas || []);
      setEvidences(
        (investigationEvidence?.length && investigationEvidence) || [
          { ...initialEvidence, incidentDetailsId },
        ]
      );
      setDocuments(
        (otherDocumentsData?.length && otherDocumentsData) || [
          { ...initialOtherDocuments, incidentDetailsId },
        ]
      );

      setMitigationMeasures(
        response.data.investigationDetails?.mitigationMeasures?.length != 0
          ? response.data.investigationDetails?.mitigationMeasures
          : [{ ...initialMitigationMeasure }]
      );
      setRootCauseDescriptions(
        (response.data.investigationDetails.rootCauseDescriptions?.length &&
          response.data.investigationDetails.rootCauseDescriptions) || [
          { ...initialRootCauseDescription, incidentDetailsId },
        ]
      );
      setImmediateCause(
        (response.data.investigationDetails?.immediateCause?.length &&
          response.data.investigationDetails?.immediateCause) || [
          { ...initialImmediateCause, incidentDetailsId },
        ]
      );
      setIndirectCause(
        (response.data.investigationDetails?.indirectCause?.length &&
          response.data.investigationDetails?.indirectCause) || [
          { ...initialIndirectCause, incidentDetailsId },
        ]
      );
      setRootCause(response.data.investigationDetails.rootCause || "");
      setSolutions(response.data.solutions || []);
      setComments(
        response.data?.comments?.filter(
          (data) => data.type === commentTypes.investigation
        ) || []
      );
    });
  }, [incidentDetailsId]);
  // console.log("mitigationMeasures******///", evidences);

  // console.log("form", form);
  return (
    <>
      <div className="healthSafetyEnvironmentWrapper">
        <div className="healthSafetyEnvironmentWrapper incidentMenu">
          <div className="hseMenuLinks card pointer" style={{ minHeight: 75 }}>
            <a className={`${tab === 1 ? "active" : ""}`} href onClick={() => setTab(1)}>
              Timeline
            </a>

            <a className={`${tab === 2 ? "active" : ""}`} href onClick={() => setTab(2)}>
              Mitigtion Measures
            </a>

            <a className={`${tab === 3 ? "active" : ""}`} href onClick={() => setTab(3)}>
              Witness Statements
            </a>

            <a className={`${tab === 4 ? "active" : ""}`} href onClick={() => setTab(4)}>
              Root Cause Analysis
            </a>

            <a className={`${tab === 5 ? "active" : ""}`} href onClick={() => setTab(5)}>
              Investigaton Evidence
            </a>

            <a className={`${tab === 6 ? "active" : ""}`} href onClick={() => setTab(6)}>
              Other Documents
            </a>

            <a className={`${tab === 7 ? "active" : ""}`} href onClick={() => setTab(7)}>
              CAPA
            </a>

            <a className={`${tab === 8 ? "active" : ""}`} href onClick={() => setTab(8)}>
              Workflow Inputs
            </a>
          </div>
        </div>
      </div>
      <Row>
        <Col lg={9}>
          {tab === 1 && (
            <IncidentTimeline
              reportDate={form.reportDate}
              reporter={form.reporter}
              investigationCompletionDate={form.investigationCompletionDate}
              reviewCompletionDate={form.reviewCompletionDate}
              investigationDetails={form?.investigationDetails}
              reviewer={form.reviewer}
              closer={form.closer}
              personalDetails={form.personalDetails}
              vehicleDetails={form.vehicleDetails}
              assetDetails={form.assetDetails}
              spills={form.spills}
              investigationCompleted={form.investigationCompleted}
              reviewCompleted={form.reviewCompleted}
              closureCompleted={form.closureCompleted}
              isAssetIncident={form.isAssetIncident}
              isPersonalInjury={form.isPersonalInjury}
              isSpillsIncident={form.isSpillsIncident}
              isVehicleIncident={form.isVehicleIncident}
              closureCompletionDate={form.closureCompletionDate}
              incidentStatus={form.incidentStatus}
              insuranceApplicable={form.insuranceApplicable}
              complianceRequired={form.complianceRequired}
              trainingRequired={form.trainingRequired}
              witnessStatementRequired={form.witnessStatementRequired}
              rootCauseAnalysisRequired={form.rootCauseAnalysisRequired}
              solutionRequired={form.solutionRequired}
              capaRequired={form.capaRequired}
              reportEvidencesRequired={form.reportEvidencesRequired}
              evidencesRequired={form.evidencesRequired}
              reviewEvidencesRequired={form.reviewEvidencesRequired}
              incidentId={form.incidentId}
              incidentDate={form.incidentDate}
              type={form.type}
              severity={form.severity}
              severityPostReview={form.severityPostReview}
              workArea={form.workArea}
              site={form.site}
              department={form.department}
              capaCompletionDate={form?.capaCompletionDate}
              capaCompletedByData={form?.capaCompletedByData}
              finalReviewedByDate={form?.finalReviewedByDate}
              finalReviewedByData={form?.finalReviewedByData}
              reviewedByMMDate={form?.reviewedByMMDate}
              reviewedByMMData={form?.reviewedByMMData}
              reviewedDate={form?.reviewedDate}
              staffData={form?.staffData}
              staffType={form?.staffType}
              otherStaffName={form?.otherStaffName}
              area={form.area}
              capasList={capas}
              reportAtLabel={FORM_LABEL_OFFICER[form?.reportAtLabel]}
              form={form}
            />
          )}

          {/* {tab === 2 && (
            <div className="card p-3 pb-0 mt-4 EHS_module_create_form">
              <div className="simple-card-title">
                <h3 className="text-capitalize mb-0">Reviewer Inputs</h3>
              </div>
              <div className="ehsFormWrapper">
                <div className="w-100"></div>
              </div>
            </div>
          )} */}

          {tab === 2 && (
            <div className="card p-3 pb-0 mt-4 EHS_module_create_form">
              <div className="simple-card-title">
                <h3 className="text-capitalize mb-0">Mitigation Measures</h3>
              </div>
              <MultiLineTextArea
                title="Mitigation Measures"
                dataArray={mitigationMeasures}
                errorArray={mitigationMeasuresErrors}
                onChange={onChangeMitigationMeasure}
                onDelete={deleteMitigationMeasure}
                onAdd={addMitigationMeasure}
              />
              <ButtonsContainer
                onSubmit={onSubmit}
                lastTab={13}
                tab={tab}
                setTab={setTab}
              />
            </div>
          )}
          {tab === 3 && (
            <div className="card p-3 pb-0 mt-4 EHS_module_create_form">
              <div className="simple-card-title">
                <h3 className="text-capitalize mb-0">Witness Statements</h3>
              </div>
              <div className="ehsFormWrapper">
                <Row>
                  <Col lg={8} className="mb-2">
                    <YesOrNo
                      title="Witness Statements"
                      name="witnessStatementRequired"
                      value={form?.witnessStatementRequired ? true : false}
                      onChange={onChange}
                      acceptTitle="Available"
                      rejectTitle="Not Applicable"
                    />
                    <span className="small text-danger">
                      {errorForm.witnessStatementRequired}
                    </span>
                  </Col>
                </Row>
                {form?.witnessStatementRequired && (
                  <div className="w-100">
                    <div className="table-responsive">
                      <table id="user_table" className="table table-bordered mb-3">
                        <thead>
                          <tr>
                            <th scope="col">S.No.</th>
                            <th scope="col">Witness Name</th>
                            <th scope="col">Date of Statement</th>
                            <th scope="col">Brief Description</th>
                            <th scope="col">Statement Evidence</th>
                            <th scope="col">Remove</th>
                          </tr>
                        </thead>
                        <tbody>
                          {witnessStatements.length > 0 ? (
                            witnessStatements.map((x, index) => {
                              return x.deleted ? null : (
                                <tr key={index}>
                                  <th>{index + 1}</th>
                                  <td>
                                    <input
                                      name="name"
                                      value={x.name}
                                      onChange={({ target: { name, value } }) =>
                                        onChangeWitnessStatement({ name, value, index })
                                      }
                                      className="form-control"
                                    />
                                    <span className="small text-danger">
                                      {witnessStatementsErrors[index]?.name}
                                    </span>
                                  </td>
                                  <td>
                                    <div className="calenderFixed">
                                      <CustomDateTime
                                        name="date"
                                        value={x.date}
                                        readOnly
                                        closeOnSelect
                                        isValidDate={(day) =>
                                          disableFutureDate(day) &&
                                          day.isSameOrAfter(
                                            YYYYMMDDFormat(form?.incidentDate)
                                          )
                                        }
                                        onChange={(moment, name) =>
                                          onChangeWitnessStatement({
                                            name,
                                            index,
                                            value: moment.format("YYYY-MM-DD"),
                                          })
                                        }
                                        // isValidDate={(day) => day.isBefore(new Date())}
                                      />
                                    </div>
                                    <span className="small text-danger">
                                      {witnessStatementsErrors[index]?.date}
                                    </span>
                                  </td>
                                  <td>
                                    <input
                                      name="description"
                                      value={x.description}
                                      onChange={({ target: { name, value } }) =>
                                        onChangeWitnessStatement({ name, value, index })
                                      }
                                      className="form-control"
                                    />
                                    <span className="small text-danger">
                                      {witnessStatementsErrors[index]?.description}
                                    </span>
                                  </td>
                                  <td>
                                    <SingleFileUpload
                                      clsName="form-group"
                                      nonlabel
                                      selectedFile={x.file}
                                      deleteDocumentFile={() => onDeleteFile(index)}
                                      onFileChange={(_event, responseData) =>
                                        onChangeFile(responseData, index)
                                      }
                                    />
                                  </td>
                                  <td>
                                    <div className="actionIconsGroup">
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip id="tooltip-top">Delete</Tooltip>
                                        }
                                      >
                                        <span
                                          onClick={() => deleteWitnessStatement(index)}
                                          className="pointer icons text-danger font-20"
                                        >
                                          <FiMinusCircle />
                                        </span>
                                      </OverlayTrigger>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan="10" align="center">
                                {/* <div className="alert alert-danger d-inline-block m-0">
                                                                    <strong>Empty</strong>
                                                                </div> */}
                              </td>
                            </tr>
                          )}
                          <tr>
                            <td colSpan="10">
                              <OverlayTrigger
                                placement="top"
                                overlay={<Tooltip id="tooltip-top">Add Row</Tooltip>}
                              >
                                <Button
                                  className="addRowPluseIcon"
                                  onClick={addWitnessStatement}
                                >
                                  <FiPlusCircle />
                                </Button>
                              </OverlayTrigger>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>
              <ButtonsContainer
                onSubmit={onSubmit}
                lastTab={13}
                tab={tab}
                setTab={setTab}
              />
            </div>
          )}
          {tab === 4 && (
            <div className="card p-3 pb-0 mt-4 EHS_module_create_form">
              <div className="simple-card-title">
                <h3 className="text-capitalize mb-0">Root Cause Analysis</h3>
              </div>
              <div className="ehsFormWrapper">
                <Row>
                  <Col lg={8} className="mb-2">
                    <YesOrNo
                      title="Root Cause Analysis Performed"
                      name="rootCauseAnalysisRequired"
                      value={form?.rootCauseAnalysisRequired ? true : false}
                      onChange={onChange}
                      acceptTitle="Yes"
                      rejectTitle="Not Applicable"
                    />
                    <span className="small text-danger">
                      {errorForm.rootCauseAnalysisRequired}
                    </span>
                  </Col>
                </Row>
                {form?.rootCauseAnalysisRequired && (
                  <>
                    <Row>
                      <Col lg={4}>
                        <div className="form-group">
                          <label>Root Cause</label>
                          <SimpleSelect
                            className="form-control"
                            name="rootCause"
                            value={form?.rootCause}
                            onChange={onChange}
                            id="id"
                            label="name"
                            options={[
                              {
                                id: "Poor Employee development - Training",
                                name: "Poor Employee development - Training",
                              },
                              {
                                id: "Poor Employee Accountability",
                                name: "Poor Employee Accountability",
                              },
                              {
                                id: "Poor HIRA & Control measures in place",
                                name: "Poor HIRA & Control measures in place",
                              },
                              {
                                id: "Proper SOPs/Guidelines not developed",
                                name: "Proper SOPs/Guidelines not developed",
                              },
                              {
                                id: "SOPs/Guidelines not reviewed",
                                name: "SOPs/Guidelines not reviewed",
                              },
                              {
                                id: "SOPs/Guidelines not distributed",
                                name: "SOPs/Guidelines not distributed",
                              },
                              {
                                id: "Poor Task Instructions",
                                name: "Poor Task Instructions",
                              },
                              {
                                id: "Poor Communication",
                                name: "Poor Communication",
                              },
                              {
                                id: "Poor Employee Involvement",
                                name: "Poor Employee Involvement",
                              },
                              {
                                id: "Engineering design overlooked",
                                name: "Engineering design overlooked",
                              },
                              {
                                id: "Deficient workplace examination process ",
                                name: "Deficient workplace examination process ",
                              },
                              {
                                id: "Poor Equipment Examination process",
                                name: "Poor Equipment Examination process",
                              },
                              {
                                id: "Poor maintenance process",
                                name: "Poor maintenance process",
                              },
                              {
                                id: "Monitoring controls not in place",
                                name: "Monitoring controls not in place",
                              },

                              {
                                id: "Poor Corrective action follow-up",
                                name: "Poor Corrective action follow-up",
                              },

                              {
                                id: "Poor Material Management",
                                name: "Poor Material Management",
                              },

                              {
                                id: "Inadequate Human Resource",
                                name: "Inadequate Human Resource",
                              },

                              {
                                id: "Long hours of work/retention on OT",
                                name: "Long hours of work/retention on OT",
                              },

                              {
                                id: "Permit System not in place",
                                name: "Permit System not in place",
                              },

                              {
                                id: "Poor Occupational Health Monitoring",
                                name: "Poor Occupational Health Monitoring",
                              },
                              {
                                id: "Poor Contractor Management",
                                name: "Poor Contractor Management",
                              },
                              {
                                id: "Poor Emergency preparedness",
                                name: "Poor Emergency preparedness",
                              },
                              {
                                id: "other",
                                name: "Other",
                              },
                            ]}
                            init="Select"
                          ></SimpleSelect>
                          <span className="small text-danger">{errorForm.rootCause}</span>
                        </div>
                      </Col>
                      {rootCauseOther && (
                        <Col lg={4}>
                          <div className="form-group">
                            <label>Root Cause Other</label>
                            <FormInput
                              // label={""}
                              name="rootCauseOther"
                              value={form?.rootCauseOther}
                              onChange={onChange}
                              // readOnly={true}
                              type="text"
                            ></FormInput>
                          </div>
                        </Col>
                      )}
                    </Row>
                    <Row>
                      <Col lg={12}>
                        <MultiLineTextArea
                          title="Cause Description"
                          dataArray={rootCauseDescriptions}
                          errorArray={rootCauseDescriptionsErrors}
                          onChange={onChangeRootCauseDescription}
                          onDelete={deleteRootCauseDescription}
                          onAdd={addRootCauseDescription}
                          isLimit
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col lg={4}>
                        <div className="form-group">
                          <label>Immediate Cause</label>
                          <select
                            className="form-control"
                            name="causeImmediate"
                            value={form?.causeImmediate}
                            onChange={onChange}
                            id="id"
                            label="name"
                          >
                            <option value="none" selected disabled hidden>
                              Select
                            </option>
                            <optgroup label="A. Unsafe Act">
                              <option value="Unfit for duty">Unfit for duty</option>
                              <option value="Under influence of alcohol">
                                Under influence of alcohol
                              </option>
                              <option value="Operating without authority">
                                Operating without authority
                              </option>
                              <option value="Improper loading/lifting">
                                Improper loading/lifting
                              </option>
                              <option value="Failed to use PPEs">
                                Failed to use PPEs
                              </option>
                              <option value="Inadequate pre-op inspection of equipment/Area">
                                Inadequate pre-op inspection of equipment/Area
                              </option>
                              <option value="Operating at dangerous speed">
                                Operating at dangerous speed
                              </option>
                              <option value="Failed to follow rules/SOP">
                                Failed to follow rules/SOP
                              </option>
                              <option value="Using defective equipment/tools">
                                Using defective equipment/tools
                              </option>
                              <option value="Using equipment improperly">
                                Using equipment improperly
                              </option>
                              <option value="Removing safety devices">
                                Removing safety devices
                              </option>
                              <option value="Horseplay">Horseplay</option>
                              <option value="Failure to secure">Failure to secure</option>
                              <option value="UAOther">Other</option>
                            </optgroup>
                            <optgroup label="B. Unsafe Conditions">
                              <option value="Inadequate guards/safety devices">
                                Inadequate guards/safety devices
                              </option>
                              <option value="Inadequate warning system">
                                Inadequate warning system
                              </option>
                              <option value="Defective equipment/tools/material">
                                Defective equipment/tools/material
                              </option>
                              <option value="Poor housekeeping">Poor housekeeping</option>
                              <option value="Poor or excessive illumination">
                                Poor or excessive illumination
                              </option>
                              <option value="Poor ventilation, smoke, fumes">
                                Poor ventilation, smoke, fumes
                              </option>
                              <option value="Hazardous environment – dust">
                                Hazardous environment – dust
                              </option>
                              <option value="Hazardous environment – noise">
                                Hazardous environment – noise
                              </option>
                              <option value="Hazardous environment – temperature">
                                Hazardous environment – temperature
                              </option>
                              <option value="Defective PPEs">Defective PPEs</option>
                              <option value="Fire hazard">Fire hazard</option>
                              <option value="Inadequacy in design of workplace">
                                Inadequacy in design of workplace
                              </option>
                              <option value="Inadequacy in design of workplace">
                                Inadequacy in design of workplace
                              </option>
                              <option value="UCOther">Other</option>
                            </optgroup>
                          </select>
                          <span className="small text-danger">
                            {errorForm.causeImmediate}
                          </span>
                        </div>
                      </Col>
                      {uaOther && (
                        <Col lg={4}>
                          <div className="form-group">
                            <label>UA Cause Other</label>
                            <FormInput
                              // label={""}
                              name="uaCauseOther"
                              value={form?.uaCauseOther}
                              onChange={onChange}
                              // readOnly={true}
                              type="text"
                            ></FormInput>
                          </div>
                        </Col>
                      )}
                      {ucOther && (
                        <Col lg={4}>
                          <div className="form-group">
                            <label>UC Cause Other</label>
                            <FormInput
                              // label={""}
                              name="ucCauseOther"
                              value={form?.ucCauseOther}
                              onChange={onChange}
                              // readOnly={true}
                              type="text"
                            ></FormInput>
                          </div>
                        </Col>
                      )}
                    </Row>
                    <Row>
                      <Col lg={12}>
                        <MultiLineTextArea
                          title="Cause Description"
                          dataArray={immediateCause}
                          errorArray={immediateCauseErrors}
                          onChange={onChangeImmediateCause}
                          onDelete={deleteImmediateCause}
                          onAdd={addImmediateCause}
                          isLimit
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col lg={4}>
                        <div className="form-group">
                          <label>Indirect Cause</label>
                          <select
                            className="form-control"
                            name="causeIndirect"
                            value={form?.causeIndirect}
                            onChange={onChange}
                            id="id"
                            label="name"
                          >
                            <option value="none" selected disabled hidden>
                              Select
                            </option>
                            <optgroup label="A. Personal Factors">
                              <option value="Vision/hearing/respiratory deficiency">
                                Vision/hearing/respiratory deficiency
                              </option>
                              <option value="Poor intelligence/misunderstood directions">
                                Poor intelligence/misunderstood directions
                              </option>
                              <option value="Fatigue due to task duration/concentration">
                                Fatigue due to task duration/concentration
                              </option>
                              <option value="Constrained movement">
                                Constrained movement
                              </option>
                              <option value="Poor judgment/slow reaction">
                                Poor judgment/slow reaction
                              </option>
                              <option value="Exposure to hazardous environment">
                                Exposure to hazardous environment
                              </option>
                              <option value="Confusing/improper direction">
                                Confusing/improper direction
                              </option>
                              <option value="Lack of experience/knowledge">
                                Lack of experience/knowledge
                              </option>
                              <option value="Inadequate training">
                                Inadequate training
                              </option>
                              <option value="Inadequate Instructions">
                                Inadequate Instructions
                              </option>
                              <option value="Taking short cuts">Taking short cuts</option>
                              <option value="Unnecessary aggression">
                                Unnecessary aggression
                              </option>
                              <option value="Improper motivation/production incentives">
                                Improper motivation/production incentives
                              </option>
                              <option value="Improper supervision – unsafe acts overlooked">
                                Improper supervision – unsafe acts overlooked
                              </option>
                              <option value="pfOther">Other</option>
                            </optgroup>
                            <optgroup label="B.Job Factors">
                              <option value="Inadequate Training">
                                Inadequate Training
                              </option>
                              <option value="Poor Coordination/Unclear reporting">
                                Poor Coordination/Unclear reporting
                              </option>
                              <option value="SOP/guidelines unclear or inadequate">
                                SOP/guidelines unclear or inadequate
                              </option>
                              <option value="Inadequate assessment of risk & control intents">
                                Inadequate assessment of risk & control intents
                              </option>
                              <option value="Inadequate Instructions">
                                Inadequate Instructions
                              </option>
                              <option value="Poor work Planning">
                                Poor work Planning
                              </option>
                              <option value="Inadequacy in workplace design">
                                Inadequacy in workplace design
                              </option>
                              <option value="Poor Construction">Poor Construction</option>
                              <option value="Inadequacy in workplace environment">
                                Inadequacy in workplace environment
                              </option>
                              <option value="Inadequacy in maintenance of equipment">
                                Inadequacy in maintenance of equipment
                              </option>
                              <option value="Inadequacy in examination/inspection">
                                Inadequacy in examination/inspection
                              </option>
                              <option value="Inadequacy in testing & making adjustments">
                                Inadequacy in testing & making adjustments
                              </option>
                              <option value="Defective equipment allowed to run">
                                Defective equipment allowed to run
                              </option>
                              <option value="Poor availability of tools & tackles">
                                Poor availability of tools & tackles
                              </option>
                              <option value="Inadequate leadership">
                                Inadequate leadership
                              </option>
                              <option value="jfOther">Other</option>
                            </optgroup>
                          </select>
                          <span className="small text-danger">
                            {errorForm.causeIndirect}
                          </span>
                        </div>
                      </Col>
                      {jfOther && (
                        <Col lg={4}>
                          <div className="form-group">
                            <label>Job Factor Cause Other</label>
                            <FormInput
                              // label={""}
                              name="jfCauseOther"
                              value={form?.jfCauseOther}
                              onChange={onChange}
                              // readOnly={true}
                              type="text"
                            ></FormInput>
                          </div>
                        </Col>
                      )}
                      {pfOther && (
                        <Col lg={4}>
                          <div className="form-group">
                            <label>Person Factor Cause Other</label>
                            <FormInput
                              // label={""}
                              name="pfCauseOther"
                              value={form?.pfCauseOther}
                              onChange={onChange}
                              // readOnly={true}
                              type="text"
                            ></FormInput>
                          </div>
                        </Col>
                      )}
                    </Row>
                    <Row>
                      <Col lg={12}>
                        <MultiLineTextArea
                          title="Cause Description"
                          dataArray={indirectCause}
                          errorArray={indirectCauseErrors}
                          onChange={onChangeIndirectCause}
                          onDelete={deleteIndirectCause}
                          onAdd={addIndirectCause}
                          isLimit
                        />
                      </Col>
                    </Row>
                  </>
                )}
              </div>
              <ButtonsContainer
                onSubmit={onSubmit}
                lastTab={13}
                tab={tab}
                setTab={setTab}
              />
            </div>
          )}
          {tab === 5 && (
            <div className="card p-3 pb-0 mt-4 EHS_module_create_form">
              <div className="simple-card-title">
                <h3 className="text-capitalize mb-0">Investigation Evidence</h3>
              </div>
              <div className="ehsFormWrapper">
                <div className="w-100">
                  <Row className="mb-3">
                    <Col lg={8} className="mb-2">
                      <YesOrNo
                        title="Investigation Evidence"
                        name="evidencesRequired"
                        value={form?.evidencesRequired ? true : false}
                        onChange={onChange}
                        acceptTitle="Available"
                        rejectTitle="Not Available"
                      />
                      <span className="small text-danger">
                        {errorForm.evidencesRequired}
                      </span>
                    </Col>
                  </Row>
                  {form?.evidencesRequired && (
                    <IncidentEvidences
                      dataArray={evidences}
                      errorArray={evidencesErrors}
                      onChange={onChangeEvidence}
                      onChangeFile={onChangeEvidenceFile}
                      onAdd={addEvidence}
                      onDelete={deleteEvidence}
                    />
                  )}
                </div>
              </div>
              <ButtonsContainer
                onSubmit={onSubmit}
                lastTab={13}
                tab={tab}
                setTab={setTab}
              />
            </div>
          )}
          {tab === 6 && (
            <div className="card p-3 pb-0 mt-4 EHS_module_create_form">
              <div className="simple-card-title">
                <h3 className="text-capitalize mb-0">Other Documents</h3>
              </div>
              <div className="ehsFormWrapper">
                <div className="w-100">
                  <Row className="mb-3">
                    <Col lg={8} className="mb-2">
                      <YesOrNo
                        title="Other Documents"
                        name="otherDocumentRequired"
                        value={form?.otherDocumentRequired ? true : false}
                        onChange={onChange}
                        acceptTitle="Available"
                        rejectTitle="Not Available"
                      />
                      <span className="small text-danger">
                        {errorForm.otherDocumentRequired}
                      </span>
                    </Col>
                  </Row>
                  {form?.otherDocumentRequired ? (
                    <IncidentEvidences
                      dataArray={documents}
                      errorArray={documentsErrors}
                      onChange={onChangeDocuments}
                      onChangeFile={onChangeDocumentsFile}
                      onAdd={addDocuments}
                      onDelete={deleteDocuments}
                      isDocuments
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <ButtonsContainer
                onSubmit={onSubmit}
                lastTab={13}
                tab={tab}
                setTab={setTab}
              />
            </div>
          )}
          {tab === 7 && (
            <div className="card p-3 pb-0 mt-4 EHS_module_create_form">
              <div className="simple-card-title">
                <h3 className="text-capitalize mb-0">Add CAPA</h3>
              </div>
              <div className="ehsFormWrapper">
                <Row className="d-none">
                  <Col lg={8} className="mb-2">
                    <YesOrNo
                      title="Corrective & Preventive Actions"
                      name="capaRequired"
                      value={form.capaRequired}
                      onChange={onChange}
                      acceptTitle="Applicable"
                      rejectTitle="Not Applicable"
                    />
                    <span className="small text-danger">{errorForm.capaRequired}</span>
                  </Col>
                </Row>
                {/* {form.capaRequired && ( */}
                <div className="w-100">
                  <Capas
                    capas={capas}
                    capasErrors={capasErrors}
                    onChangeCapa={onChangeCapa}
                    addCapa={addCapa}
                    deleteCapa={deleteCapa}
                    users={users}
                    departments={departments}
                    area={area}
                    capaowner={capaOwners}
                    incidentsOnly
                    isValidDate={(day) =>
                      day.isSameOrAfter(YYYYMMDDFormat(form?.incidentDate))
                    }
                    siteId={form?.siteId}
                  />
                </div>
                {/* )} */}
              </div>
              <ButtonsContainer
                onSubmit={onSubmit}
                lastTab={13}
                tab={tab}
                setTab={setTab}
              />
            </div>
          )}
          {tab === 8 && (
            <div className="card p-3 pb-2 mt-4 EHS_module_create_form">
              <div className="simple-card-title mb-0">
                <h3 className="text-capitalize mb-0">Investigation</h3>
              </div>
              <div className="ehsFormWrapper">
                <Row>
                  <Col lg={8}>
                    {/* {form.isBack === 1 && (
                      <p style={{ color: "red" }}>
                        {form?.backData?.length > 0 &&
                          form?.backData[form.backData.length - 1]?.comment}
                      </p>
                    )} */}
                    {/* <IncidentComments comments={comments} setComments={setComments} type={commentTypes.investigation} /> */}
                    <ViewComments
                      comments={form.incidentReviewsData ? form.incidentReviewsData : []}
                      hideTitle
                    />
                  </Col>
                  <Col lg={4} className="mt-4">
                    <Row>
                      <Col lg={12} style={{ marginTop: "-10px" }}>
                        <div className="form-group mb-3">
                          <label>Investigated By</label>
                          <input
                            value={
                              form?.investigationDetails?.investigator
                                ? `${form?.investigationDetails?.investigator?.firstName} ${form?.investigationDetails?.investigator?.lastName}`
                                : ""
                            }
                            type="text"
                            className="form-control"
                            placeholder=""
                            readOnly
                          />
                        </div>
                      </Col>
                      <Col lg={12}>
                        <div className="form-group mb-3">
                          <label>Investigation Completion Date</label>
                          <CustomDateTime
                            name="investigationCompletionDate"
                            value={form.investigationCompletionDate}
                            isValidDate={(day) =>
                              day.isSameOrAfter(
                                moment(form.reportDate).format("YYYY-MM-DD")
                              ) && disableFutureDate(day)
                            }
                            onChange={(moment, name) =>
                              onChange({
                                target: { name, value: moment.format("YYYY-MM-DD") },
                              })
                            }
                            readOnly
                            closeOnSelect
                          />
                          <span className="small text-danger">
                            {errorForm.investigationCompletionDate}
                          </span>
                        </div>
                      </Col>
                      <Col lg={12}>
                        <div className="form-group mb-3">
                          <label>Severity Type (Reported)</label>

                          <SimpleSelect
                            name="severity"
                            value={form.severity}
                            className="form-control"
                            disabled
                            options={Object.keys(severities)}
                            object={severities}
                          ></SimpleSelect>
                        </div>
                      </Col>
                      <Col lg={12}>
                        <div className="form-group mb-3">
                          <label>Suggested Severity Type</label>

                          <SimpleSelect
                            name="investigatorSeverityPostReview"
                            value={form.investigatorSeverityPostReview}
                            onChange={onChange}
                            className="form-control"
                            options={Object.keys(severities)}
                            object={severities}
                          ></SimpleSelect>

                          <span className="small text-danger">
                            {errorForm.investigatorSeverityPostReview}
                          </span>
                        </div>
                      </Col>
                      <Col lg={12} className="my-3">
                        <div className="form-group">
                          <label>Investigation Completion Summary</label>
                          <textarea
                            class="form-control"
                            style={{ height: 180 }}
                            name="investigationCompletionSummary"
                            value={form.investigationCompletionSummary}
                            onChange={onChange}
                            placeholder="Max 500 Characters"
                            maxLength={500}
                          />
                          <span className="small text-danger">
                            {errorForm.investigationCompletionSummary}
                          </span>
                        </div>
                      </Col>
                      <Col lg={12} className="my-4">
                        <label className="checkbox checkbox-primary">
                          <input
                            type="checkbox"
                            checked={form.investigationCompleted}
                            name="investigationCompleted"
                            onChange={onChange}
                          />
                          <span>Investigation Completed</span>
                          <span className="checkmark" />
                        </label>
                        <span className="small text-danger">
                          {errorForm.investigationCompleted}
                        </span>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <ButtonsContainer
                  onSubmit={onSubmit}
                  lastTab={7}
                  tab={tab}
                  setTab={setTab}
                  noNext
                />
              </div>
            </div>
          )}

          <div className="mt-4 text-center filterFormDivider">
            <span className="btn btn-secondary mx-2" onClick={history.goBack}>
              Go Back to Main Menu
            </span>
          </div>
        </Col>
        <Col lg={3}>
          <div className="mt-4">
            <h5>You are editing as an Investigator.</h5>
            <Accordion>
              <div className="mb-3">
                <Accordion.Toggle
                  as={Card.Header}
                  eventKey="10"
                  className="rightIncidentCard p-0"
                >
                  <div className="rightInfoTitle">
                    Reporter
                    <MdKeyboardArrowRight />
                  </div>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="10">
                  <Card.Body className="p-0">
                    <IncidentDetailsInfo
                      country={form.country}
                      state={form.state}
                      longDurationFire={form.longDurationFire}
                      lostManhoursEmployees={form.lostManhoursEmployees}
                      lostManhoursContractors={form.lostManhoursContractors}
                      lostManhoursOthers={form.lostManhoursOthers}
                      department={form.department}
                      description={form.description}
                      equipmentFailure={form.equipmentFailure}
                      fallOfObject={form.fallOfObject}
                      inundation={form.inundation}
                      explosion={form.explosion}
                      facilityOutage={form.facilityOutage}
                      facilityShutdown={form.facilityShutdown}
                      facilityStatus={form.facilityStatus}
                      fatalityEmployees={form.fatalityEmployees}
                      fatalityContractors={form.fatalityContractors}
                      fatalityOthers={form.fatalityOthers}
                      fireInvolved={form.fireInvolved}
                      functionData={form.functionData}
                      incidentDate={form.incidentDate}
                      incidentId={form.incidentId}
                      incidentStatus={form.incidentStatus}
                      indirectLosses={form.indirectLosses}
                      injuredEmployees={form.injuredEmployees}
                      injuredContractors={form.injuredContractors}
                      injuredOthers={form.injuredOthers}
                      measuresOrActions={form.measuresOrActions}
                      peopleCount={form.peopleCount}
                      permanentDisability={form.permanentDisability}
                      reportDate={form.reportDate}
                      severity={form.severity}
                      site={form.site}
                      reportedBy={form.reporter}
                      similarIncidentHappened={form.similarIncidentHappened}
                      summary={form.summary}
                      workArea={form.workArea}
                      type={form.type}
                      personalDetails={form.personalDetails}
                      assetDetails={form.assetDetails}
                      vehicleDetails={form.vehicleDetails}
                      spills={form.spills}
                      evidences={form.evidences?.filter(
                        (data) => data.category === evidenceCategories.report
                      )}
                      regionalOffice={form.site ? form.site.parentSite : ""}
                      staffType={form.staffType}
                      staffEmployer={
                        form?.staffType === "contractor"
                          ? form?.StaffNameObject?.contractors?.contractorLegalEntity
                          : STAFFEMPLOYER.find((d) => d.id === form?.staffEmployer)
                              ?.contactPerson
                      }
                      staffName={
                        form?.staffType === "employee"
                          ? `${employeeDropdownLabel(form?.staffData)}`
                          : form?.staffType === "contractor"
                          ? `${contractorDropdownLabel(form?.staffData)}`
                          : form?.otherStaffName
                      }
                      area={form.area}
                      subArea={form.subArea}
                      subAreaId={form.subAreaId}
                      otherSubArea={form.otherSubArea}
                      shift={form.shift}
                      activity={form.activity}
                      subActivity={form.subActivity}
                      capasDetails={form.capas}
                      locationSiteId={form?.locationSiteId}
                      roSiteId={form?.roSiteId}
                      contractors={contractors}
                      alcoholViolator={form.alcoholViolator}
                      ppeViolator={form.ppeViolator}
                      unfitBuyerTruck={form.unfitBuyerTruck}
                      unfitHEMM={form.unfitHEMM}
                    />
                  </Card.Body>
                </Accordion.Collapse>
              </div>

              {form.severity > 3 && form?.investigationDetails && (
                <div className="mb-3">
                  <Accordion.Toggle
                    as={Card.Header}
                    eventKey="11"
                    className="rightIncidentCard p-0"
                  >
                    <div className="rightInfoTitle">
                      Investigator <MdKeyboardArrowRight />
                    </div>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="11">
                    <Card.Body className="p-0">
                      <ReviewerDetailsInfo
                        incident={form}
                        investigationCompletionDate={
                          form?.investigationDetails?.investigationCompletionDate
                        }
                        investigationCompletionSummary={
                          form?.investigationDetails?.investigationCompletionSummary
                        }
                        severity={form?.investigationDetails?.severity}
                        insuranceApplicable={
                          form?.investigationDetails?.insuranceApplicable
                        }
                        insuranceClaimRaised={
                          form?.investigationDetails?.insuranceClaimRaised
                        }
                        insuranceClaimAmount={
                          form?.investigationDetails?.insuranceClaimAmount
                        }
                        insuranceApprovedAmount={
                          form?.investigationDetails?.insuranceApprovedAmount
                        }
                        insuranceUnapprovedAmount={
                          form?.investigationDetails?.insuranceUnapprovedAmount
                        }
                        cause={form?.investigationDetails?.cause}
                        fireCause={form?.investigationDetails?.fireCause}
                        avoidable={form?.investigationDetails?.avoidable}
                        couldAvoidBy={form?.investigationDetails?.couldAvoidBy}
                        environmentalImpact={
                          form?.investigationDetails?.environmentalImpact
                        }
                        solutionType={form?.investigationDetails?.solutionType}
                        compliances={form?.investigationDetails?.compliances}
                        trainings={form?.investigationDetails?.trainings}
                        mitigationMeasures={
                          form?.investigationDetails?.mitigationMeasures
                        }
                        witnessStatements={form?.witnessStatements}
                        rootCauseDescriptions={rootCauseDescriptions}
                        immediateCause={immediateCause}
                        indirectCause={indirectCause}
                        causeIndirect={form?.causeIndirect}
                        causeImmediate={form?.causeImmediate}
                        solutions={form?.investigationDetails?.solutions}
                        capas={capas}
                        investigator={form?.investigationDetails?.investigator}
                        evidences={form.investigationDetails?.investigationEvidences?.filter(
                          (data) => data.category === evidenceCategories.investigation
                        )}
                        documents={form?.investigationDetails?.documents?.filter(
                          (data) =>
                            data.category === evidenceCategories.investigationOther
                        )}
                        comments={form.comments?.filter(
                          (data) => data.type === commentTypes.investigation
                        )}
                        users={users}
                        targetCompletionDate={
                          form?.investigationDetails?.targetCompletionDate
                        }
                        rootCause={
                          form?.investigationDetails?.rootCause || form?.rootCause
                        }
                        area={area}
                        severityPostReview={form?.severityPostReview}
                      />
                    </Card.Body>
                  </Accordion.Collapse>
                </div>
              )}
            </Accordion>
          </div>
        </Col>
      </Row>
    </>
  );
};

const ButtonsContainer = ({ tab, setTab, lastTab, onSubmit, noNext = false }) => (
  <div className="stepperFormButtons">
    {tab > 1 && (
      <span className="pointer btn btn-left" onClick={() => setTab((prev) => prev - 1)}>
        <BsArrowLeft /> Back
      </span>
    )}
    {!noNext && tab < lastTab && (
      <span
        className="pointer btn btn-right"
        onClick={() => {
          // onSubmit(false, true);
          setTab((prev) => prev + 1);
        }}
      >
        Next
        <BsArrowRight />
      </span>
    )}
    {noNext && (
      <span className="pointer btn btn-right" onClick={() => onSubmit(true)}>
        Close Investigation
      </span>
    )}
  </div>
);

const mapStateToProps = (state) => ({
  user: state.user?.user,
});

export default connect(mapStateToProps)(IncidentInvestigationForm);
